import { Stack, Text } from '@mantine/core';
import { DetailCard, type WaRendererProps } from './primitives';

/** Inbound Flow (form) submission — the answers as a key→value card. */
export function FlowResponseCard({ view }: WaRendererProps) {
  const answers = view.flowResponse;
  if (!answers || answers.length === 0) return null;
  return (
    <DetailCard title="📋 Form response">
      <Stack gap={2}>
        {answers.map((a) => (
          <Text key={a.key} size="xs">
            <Text span fw={600}>
              {a.key}:
            </Text>{' '}
            {a.value}
          </Text>
        ))}
      </Stack>
    </DetailCard>
  );
}
